@switch (connectivity.status$ | async) {
	@case (EConnectivityStatus.offline) {
		<mat-toolbar style="background-color: #b70000">
			<div class="flex flex-row items-center justify-center w-full">
				<mat-icon class="text-white">cloud_off</mat-icon>
				<div class="text-white font-bold">{{ "core.internet-lost" | translate }}</div>
			</div>
		</mat-toolbar>
	}
	@case (EConnectivityStatus.slow) {
		<mat-toolbar style="background-color: #f0b400">
			<div class="flex flex-row items-center justify-center w-full">
				<mat-icon class="text-black">cloud_queue</mat-icon>
				<div class="text-black font-bold">{{ "core.internet-slow" | translate }}</div>
			</div>
		</mat-toolbar>
	}
}
@if (maintenance.showScreen()) {
	<app-maintenance />
} @else if (maintenance.showAdminBanner()) {
	<mat-toolbar style="background-color: #f0b400">
		<div class="flex flex-row items-center justify-center w-full">
			<mat-icon class="text-black">engineering</mat-icon>
			<div class="text-black font-bold whitespace-normal">{{ "maintenance.admin-banner" | translate }}</div>
		</div>
	</mat-toolbar>
}
<mat-sidenav-container
	class="h-full"
	autosize>
	@if (authService.isAuth() && !isSidenavHidden && !currentUrl.startsWith("/auth")) {
		<mat-sidenav
			[mode]="isSmallScreen() ? 'over' : 'side'"
			[opened]="navOpened"
			style="min-width: 300px">
			<div class="app-sidenav-content">
				<mat-toolbar
					color="primary"
					class="app-sidenav-toolbar flex flex-row justify-between">
					<div class="flex flex-col">
						<div>
							{{
								userService.getFirstName() === "__GROUP__"
									? userService.getLastName()
									: userService.getUserName()
							}}
						</div>
						<div style="margin-top: -12px; font-size: 0.7em; font-style: italic; font-weight: normal">
							{{ userService.getInstituteLabel() }}
						</div>
					</div>
					<span class="relative inline-flex">
						<img
							[src]="imgURL"
							alt="Logo"
							class="h-8 w-auto cursor-pointer"
							(click)="navigateToHome()" />
						<img
							class="santa-hat"
							src="assets/images/santa-hat.svg"
							alt=""
							*appShowInDecember />
					</span>
				</mat-toolbar>
				<mat-nav-list class="app-sidenav-nav flex flex-col">
					<div mat-subheader>{{ "APP_FUNCTIONS_MAIN" | translate }}</div>
					<a
						mat-list-item
						[routerLink]="'protocols'"
						[class.activeItem]="isProtocolsNavActive()">
						<div
							class="flex flex-row items-center"
							[class.activeItem]="isProtocolsNavActive()">
							<mat-icon matPrefix>import_contacts</mat-icon>
							<label>{{ "APP_PROTOCOLS" | translate }}</label>
						</div>
					</a>
					@for (item of navigationSpecialtyItems; track item) {
						<a
							mat-list-item
							[routerLink]="'protocols/subitems/' + item.id"
							class="protocol-specialty"
							[class.activeItem]="isProtocolsSubitemActive(item.id)">
							<div
								class="flex flex-row items-center"
								[class.activeItem]="isProtocolsSubitemActive(item.id)">
								@if (item.icon.startsWith("material")) {
									<mat-icon matPrefix>{{ getIcon(item) }}</mat-icon>
								} @else {
									<img
										alt="logo"
										src="{{ getIcon(item) }}"
										style="margin-right: 8px; width: 24px; height: 24px" />
								}

								<label>{{ item.label }}</label>
							</div>
						</a>
					}
					<a
						mat-list-item
						[routerLink]="'videos'"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>video_library</mat-icon>
							<label>{{ "videos.navigation-menu.title" | translate }}</label>
						</div>
					</a>
					<a
						mat-list-item
						[routerLink]="'pharmacy/drugs'"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>vaccines</mat-icon>
							<label>{{ "drugs.navigation-menu.title" | translate }}</label>
						</div>
					</a>
					<a
						mat-list-item
						[routerLink]="'my-protocols'"
						[class.activeItem]="isMyProtocolsNavActive()">
						<div
							class="flex flex-row items-center"
							[class.activeItem]="isMyProtocolsNavActive()">
							<mat-icon matPrefix>chrome_reader_mode</mat-icon>
							<label>{{ "APP_MY_PROTOCOLS" | translate }}</label>
						</div>
					</a>
					<a
						mat-list-item
						[routerLink]="'catalog'"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>storefront</mat-icon>
							<label>{{ "catalog.title" | translate }}</label>
						</div>
					</a>
					@if (manager.isPathwaysManager()) {
						<a
							mat-list-item
							[routerLink]="'pathways/my'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>route</mat-icon>
								<label>{{ "app.navigation.my-pathways" | translate }}</label>
							</div>
						</a>
						<a
							mat-list-item
							[routerLink]="'encounters'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>groups</mat-icon>
								<label>{{ "app.navigation.patients" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isEducationStudent()) {
						<a
							mat-list-item
							[routerLink]="'education'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>school</mat-icon>
								<label>{{ "app.navigation.education" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isExpert()) {
						<a
							mat-list-item
							[routerLink]="'remote-guidance'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>support_agent</mat-icon>
								<label>{{ "remote-guidance.title" | translate }}</label>
							</div>
						</a>
					}
					<a
						mat-list-item
						[routerLink]="'tools'"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>games</mat-icon>
							<label>{{ "tools.label" | translate }}</label>
						</div>
					</a>
					<a
						mat-list-item
						[routerLink]="'directory'"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>class</mat-icon>
							<label>{{ "APP_DIRECTORY_PHONE" | translate }}</label>
						</div>
					</a>
					<a
						mat-list-item
						[routerLink]="'misc/research'"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>science</mat-icon>
							<label>{{ "research.navigation-item" | translate }}</label>
						</div>
					</a>
					<mat-divider />
					@if (manager.isAdmin() || manager.isAdminUsers() || manager.isQualityRole()) {
						<div mat-subheader>
							{{ "APP_ADMINISTRATION" | translate }}
						</div>
					}
					@if (manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'admin/protocols'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>auto_stories</mat-icon>
								<label>{{ "APP_PROTOCOLS" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'admin/videos'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>video_library</mat-icon>
								<label>{{ "videos.navigation-menu.title" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'admin/formulas'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>games</mat-icon>
								<label>{{ "tools.formulas.label" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'dashboard'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>dashboard</mat-icon>
								<label>{{ "dashboard.title.label" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isPharmacist() || manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'pharmacy/booklet'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>medication</mat-icon>
								<label>{{ "drugs.pharmacy.label" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isQualityRole() || manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'quality'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>verified</mat-icon>
								<label>{{ "quality.title" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isAdminUsers()) {
						<a
							mat-list-item
							[routerLink]="'users'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>supervisor_account</mat-icon>
								<label>{{ "APP_USERS" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'institutes'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>location_city</mat-icon>
								<label>{{ "APP_ESTABLISHMENTS" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isManager()) {
						<a
							mat-list-item
							[routerLink]="'statistics'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>insights</mat-icon>
								<label>{{ "APP_STATISTICS" | translate }}</label>
							</div>
						</a>
					}
					@if (manager.isAdmin()) {
						<a
							mat-list-item
							[routerLink]="'admin/settings'"
							routerLinkActive="activeItem">
							<div
								class="flex flex-row items-center"
								routerLinkActive="activeItem">
								<mat-icon matPrefix>settings</mat-icon>
								<label>{{ "core.settings" | translate }}</label>
							</div>
						</a>
					}
					<mat-divider />
					<a
						mat-list-item
						routerLink="/help"
						routerLinkActive="activeItem">
						<div
							class="flex flex-row items-center"
							routerLinkActive="activeItem">
							<mat-icon matPrefix>help</mat-icon>
							<label>{{ "help.label" | translate }}</label>
						</div>
					</a>
				</mat-nav-list>
			</div>
		</mat-sidenav>
	}
	<mat-sidenav-content>
		@if (authService.isAuth() && !currentUrl.startsWith("/auth")) {
			<div class="app-toolbar-wrapper">
				<ul
					class="lightrope"
					*appShowInDecember>
					@for (light of lightropeLights; track light) {
						<li
							[class.popped]="poppedLights().has(light)"
							(click)="popLight(light)">
							<span class="lightrope-bulb"></span>
							@if (poppedLights().has(light)) {
								<span class="lightrope-burst"></span>
							}
						</li>
					}
				</ul>
				<mat-toolbar
					color="primary"
					class="app-toolbar">
					<div class="flex w-full flex-row items-center">
						@if (!isSidenavHidden) {
							<button
								mat-icon-button
								(click)="toggle()">
								<mat-icon>menu</mat-icon>
							</button>
						}
						@if (!isEducationDomain) {
							<button
								mat-icon-button
								(click)="navigateToHome()">
								<mat-icon>home</mat-icon>
							</button>
						}
						<div class="flex w-full flex-row justify-between ml-2">
							<div class="flex flex-col justify-center">
								<span>{{ title }}</span>
								@if (title !== "MedInThePocket") {
									<div
										style="
											margin-top: -12px;
											font-size: 0.7em;
											font-style: italic;
											font-weight: normal;
										">
										{{ description }}
									</div>
								}
							</div>
							<div class="flex flex-row items-center">
								<button
									mat-icon-button
									*appShowInDecember
									[matTooltip]="
										(cursorSparkles.enabled()
											? 'festive.sparkles.disable'
											: 'festive.sparkles.enable'
										) | translate
									"
									[attr.aria-label]="
										(cursorSparkles.enabled()
											? 'festive.sparkles.disable'
											: 'festive.sparkles.enable'
										) | translate
									"
									(click)="cursorSparkles.toggle()">
									<mat-icon>
										{{ cursorSparkles.enabled() ? "auto_fix_off" : "auto_fix_high" }}
									</mat-icon>
								</button>
								<button
									mat-icon-button
									(click)="openJanus()">
									<mat-icon>auto_awesome</mat-icon>
								</button>
								<button
									mat-icon-button
									[matTooltip]="'help-center.button.tooltip' | translate"
									(click)="helpPanel.toggle()">
									<mat-icon>help_outline</mat-icon>
								</button>
								<div>
									@if (themeService.isDarkTheme()) {
										<button
											mat-icon-button
											(click)="themeService.setLightTheme()">
											<mat-icon>light_mode</mat-icon>
										</button>
									}
									@if (!themeService.isDarkTheme()) {
										<button
											mat-icon-button
											(click)="themeService.setDarkTheme()">
											<mat-icon>dark_mode</mat-icon>
										</button>
									}
								</div>
								<app-notifications-view />
								<app-user-badge />
							</div>
						</div>
					</div>
				</mat-toolbar>
			</div>
		}
		@if (httpLoading.isLoading$ | async) {
			<mat-progress-bar
				mode="indeterminate"
				style="position: sticky; top: 0; z-index: 100" />
		}
		<router-outlet />
	</mat-sidenav-content>
</mat-sidenav-container>
<ng-container *appShowInDecember>
	<app-snow />
	@if (cursorSparkles.enabled()) {
		<app-cursor-sparkles />
	}
</ng-container>
